// Web Push subscribe/unsubscribe helpers (Phase 4). iOS 16.4+ only delivers push to an installed PWA
// (Share -> Add to Home Screen), never a plain Safari tab — same platform limit Diver's Horizon documents.

export function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

// Exported so the install-prompt UI (src/components/InstallPrompt.jsx) can reuse the same detection
// instead of a second copy — both care about "is this iOS Safari, not yet installed."
export function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

export function isStandalone() {
  return window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

/** True when push is otherwise supported but this is iOS Safari running as a plain browser tab. */
export function needsHomeScreenInstall() {
  return isIOS() && !isStandalone();
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export async function subscribeToPush() {
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notification permission denied");

  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(process.env.REACT_APP_VAPID_PUBLIC_KEY),
  });
  return subscription.toJSON();
}

export async function unsubscribeFromPush() {
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (subscription) await subscription.unsubscribe();
}
